<template>
  <footer-bar v-if="audioPlayerStore.showFooterBar"/>
  <footer class="footer-area">
    <div class="footer-area__container">
      <div class="footer-area__item footer-area__item--info">
        <nuxt-link class="footer-area__logo" to="/" @click.prevent="clearQuery">
          <img src="/assets/images/asoundeffect-logo.svg" alt="A Sound Effect Logo" />
        </nuxt-link>
        <p>
          ASoundEffect is the best place for independent sound FX, plug-ins, tools and news.
        </p>
        <footer-socials class="footer-area__socials" />
      </div>
      <div class="footer-area__item">
        <div class="footer-area__item-title">Company</div>
        <nuxt-link class="footer-area__item-link" to="/about/">About</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/about/#contact">Contact</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/terms-and-conditions/">Terms & Conditions</nuxt-link>
      </div>
      <div class="footer-area__item">
        <div class="footer-area__item-title">Licensing</div>
        <nuxt-link class="footer-area__item-link" to="/privacy-policy/">Privacy Policy</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/license-agreement/">License Agreement</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/enterprise-corporate-solutions/">Enterprise Licensing</nuxt-link>
      </div>
      <div class="footer-area__item">
        <div class="footer-area__item-title">Sign Up</div>
        <nuxt-link class="footer-area__item-link" to="/newsletter/">Newsletter</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/shop?on-sale=true">Deals</nuxt-link>
      </div>
      <div class="footer-area__item">
        <div class="footer-area__item-title">Resources</div>
        <nuxt-link class="footer-area__item-link" to="/about/#getlisted">Get Listed</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/shop/">Sound Effects</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/shop/category/plugins/">Plug-Ins</nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/shop/category/instruments/">Instruments</nuxt-link>
      </div>
      <div class="footer-area__item footer-area__item--info">
        <div class="footer-area__item-title">
          Subscribe
        </div>
        <div class="footer-area__item-child-wrapper">
          A Sound Effect Podcast

          <ul class="footer-area__child-list">
            <li>
              <a href="https://j.mp/asfxitunes" target="_blank">
                <icon-apple-podcast class="footer-area__child-list-icon" />
              </a>
            </li>
            <li>
              <a href="https://j.mp/asfxtunein" target="_blank">
                <u-i-image-handler
                  img-src="/assets/images/tunein-icon.png"
                  img-format="avif"
                  img-densities="1x 2x"
                  img-loading="lazy"
                  img-width="30px"
                  img-height="30px" />
              </a>
            </li>
            <li>
              <a href="https://j.mp/asfxsoundcloud" target="_blank">
                <u-i-image-handler
                  img-format="avif"
                  img-densities="1x 2x"
                  img-src="/assets/images/soundcloud-icon.png"
                  img-loading="lazy"
                  img-width="30"
                  img-height="30" />
              </a>
            </li>
          </ul>
        </div>
        <nuxt-link class="footer-area__item-link" to="https://feeds.feedburner.com/ASoundEffect" target="_blank">
          RSS: New blog posts
        </nuxt-link>
        <nuxt-link class="footer-area__item-link" to="/new-libraries" target="_blank" external>
          RSS: New SFX libraries
        </nuxt-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { useAudioPlayerStore } from "~/stores/audioplayer";
import { inject } from '#imports';
import IconApplePodcast from '~/assets/icons/IconApplePodcast.svg';

export default {
  components: {
    IconApplePodcast,
  },
  setup() {
    const audioPlayerStore = useAudioPlayerStore()
    const clearQuery = inject('clearQuery')

    return { audioPlayerStore, clearQuery }
  },
  data () {
    return {
      menu: [
        {
          title: 'Company',
          links: [
            {
              href: '/about',
              text: 'About'
            }
          ]
        }
      ]
    }
  },
}
</script>

<style lang="scss">
@use "~/common/scss/container";
@use "~/common/scss/variables";
@use "~/common/scss/helpers";
@use "~/common/scss/typography";
@use "~/common/scss/mq";

.footer-area {
  background-color: variables.$colorGreyFA;
  font-family: var(--footer-font-family);
  font-size: 1rem;
  padding: helpers.px-to-rem(60) 0 helpers.px-to-rem(100);
  width: 100%;

  .page-wrapper--index & {
    background-color: variables.$colorWhite;
    padding-top: helpers.px-to-rem(30);
  }

  &__container {
    @include container.l();

    border-top: 1px solid variables.$colorGreyActive;
    display: flex;
    gap: helpers.px-to-rem(24);
    justify-content: space-between;
    padding-top: helpers.px-to-rem(30);



    @include mq.mobileOnly() {
      flex-flow: row;
      flex-wrap: wrap;
      gap: 3rem;
    }
  }

  &__item {
    display: flex;
    flex-flow: column;

    @include mq.aboveMobile() {
      flex: 1 1 helpers.px-to-rem(150);

      &--info {
        flex: 1 1 helpers.px-to-rem(300);
      }
    }



    @include mq.mobileOnly() {
      width: calc(50% - 2rem);
    }
  }

  &__item--info {
    @include mq.mobileOnly() {
      width: calc(100% - 2rem);
    }
  }

  &__item-title {
    @include typography.h6();
    margin-bottom: helpers.px-to-rem(15);

    &--special {
      color: variables.$colorPurple;
    }
  }

  &__item-link {
    color: variables.$colorBlack;
    padding: helpers.px-to-rem(6) 0;
    text-decoration: none;
    transition: color .25s;

    &:hover {
      color: variables.$colorOrange;
    }
  }

  &__child-list {
    align-items: center;
    display: flex;
    gap: helpers.px-to-rem(6);
    list-style: none;
    margin-bottom: .5rem;
    padding-top: .5rem;
  }

  &__child-list-icon {
    height: helpers.px-to-rem(30);
    width: helpers.px-to-rem(30);
  }

  &__logo {
    cursor: pointer;
    margin-bottom: 1rem;

    img {
      height: helpers.px-to-rem(34);
      object-fit: contain;
      width: auto;
    }
  }

  &__socials {
    margin-top: 1rem;
  }
}
</style>